module.exports = __webpack_public_path__ + "static/media/ไดคัทตามรูป-01.1e92e136.png";